// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceConfigResponse } from './ServiceConfigResponse';
import {
  ServiceConfigResponseFromJSON,
  ServiceConfigResponseFromJSONTyped,
  ServiceConfigResponseToJSON,
  ServiceConfigResponseToJSONTyped,
} from './ServiceConfigResponse';

/**
 *
 * @export
 * @interface GetPESServiceConfigForRegionByID200Response
 */
export interface GetPESServiceConfigForRegionByID200Response {
  /**
   *
   * @type {ServiceConfigResponse}
   * @memberof GetPESServiceConfigForRegionByID200Response
   */
  data: ServiceConfigResponse;
}

/**
 * Check if a given object implements the GetPESServiceConfigForRegionByID200Response interface.
 */
export function instanceOfGetPESServiceConfigForRegionByID200Response(
  value: object,
): value is GetPESServiceConfigForRegionByID200Response {
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function GetPESServiceConfigForRegionByID200ResponseFromJSON(
  json: any,
): GetPESServiceConfigForRegionByID200Response {
  return GetPESServiceConfigForRegionByID200ResponseFromJSONTyped(json, false);
}

export function GetPESServiceConfigForRegionByID200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetPESServiceConfigForRegionByID200Response {
  if (json == null) {
    return json;
  }
  return {
    data: ServiceConfigResponseFromJSON(json['data']),
  };
}

export function GetPESServiceConfigForRegionByID200ResponseToJSON(
  json: any,
): GetPESServiceConfigForRegionByID200Response {
  return GetPESServiceConfigForRegionByID200ResponseToJSONTyped(json, false);
}

export function GetPESServiceConfigForRegionByID200ResponseToJSONTyped(
  value?: GetPESServiceConfigForRegionByID200Response | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: ServiceConfigResponseToJSON(value['data']),
  };
}
